import React from 'react';

import './styles.css';

import ModulesCard from './ModulesCard';
import { FaFutbol, FaUser, FaGavel, FaMoneyBill, FaLock, FaUsers, FaDollarSign, FaCalendar} from "react-icons/fa";
import { verifyAdmFinAccess } from '../../../services/accessServices';

export default function ModulesMenu(props) {
  const userType = localStorage.getItem("_userType");

  function selectTittle() {
    if (userType === "academia") {
      const academyInfos = JSON.parse(localStorage.getItem("_academyInfos"));
      return `${academyInfos.nome}`;
    }
    else if (userType === "professor") {
      const coachInfos = JSON.parse(localStorage.getItem("_coachInfos"));
      return `${coachInfos.nome} ${coachInfos.sobrenome}`;
    }
    else if (userType === "aluno") {
      const studentInfos = JSON.parse(localStorage.getItem("_studentInfos"));
      return `${studentInfos.nome}`;
    }
    else if (userType === "acesso") {
      const accessInfos = JSON.parse(localStorage.getItem("_accessInfos"));
      console.log("Access infos", accessInfos)
      return `${accessInfos.nome}`;
    }
    else return "Usuário não identificado";
  }

  function selectModules() {
    console.log(userType);
    
    if (userType === 'acesso') {
      const accessInfo = JSON.parse(localStorage.getItem("_accessInfos"));
      
      let access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Administrador"){
            access = true;
            return;
        }
      })
      if (access) return (
      <>
        <ModulesCard icon={<FaLock />} title={"Administrador"} to="/admin" />
        <ModulesCard icon={<FaMoneyBill />} title={"Adm/Fin"} to="/admfin" />
        <ModulesCard icon={<FaGavel />} title="Jurídico" />
        <ModulesCard icon={<FaFutbol />} title="Técnico"/>
        <ModulesCard icon={<FaUsers />} title="Sócio"/>
        <ModulesCard icon={<FaDollarSign />} title="Patrimônio"/>
        <ModulesCard icon={<FaCalendar />} title="Eventos"/>
      </>
      );

      const modules = [];


      access = false;
      access = verifyAdmFinAccess();
      if (access)
        modules.push(<ModulesCard icon={<FaMoneyBill />} title={"Adm/Fin"} to="/admfin" />);

      access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Jurídico"){
            access = true;
            return;
        }
      })
      if (access)
        modules.push(<ModulesCard icon={<FaGavel />} title="Jurídico" />);

      access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Técnico"){
            access = true;
            return;
        }
      })
      if (access)
        modules.push(<ModulesCard icon={<FaFutbol />} title="Técnico"/>);

      access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Sócio"){
            access = true;
            return;
        }
      })
      if (access)
        modules.push(<ModulesCard icon={<FaUsers />} title="Sócio"/>);

      access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Patrimônio"){
            access = true;
            return;
        }
      })
      if (access)
        modules.push(<ModulesCard icon={<FaDollarSign />} title="Patrimônio"/>);

      access = false;
      accessInfo.tipos.forEach(obj => {
        if (obj.tipo === "Eventos"){
            access = true;
            return;
        }
      })
      if (access)
        modules.push(<ModulesCard icon={<FaCalendar />} title="Eventos"/>);

      return (
        <>
        {modules}
        </>
      )

    }
    else if (userType === "academia") return (
      <ModulesCard icon={<FaFutbol />} title="Academia" to="/academia" />
    );
    else if (userType === "professor") return (
      <ModulesCard icon={<FaFutbol />} title="Academia" to="/professor" />
    );
    else if (userType === "aluno") return (
      <ModulesCard icon={<FaUser />} title="Aluno" to="/aluno" />
    );
  }

  return (
    <div className={'modules-menu' + (props.hide ? ' none-opacity' : '')}>
      <h3>
        {userType === 'academia' || userType === 'aluno' || userType === 'professor' ? "Academia" : "Gerência"} BCFC
      </h3>
      <h4>{selectTittle()}</h4>

      <p>Qual módulo deseja acessar?</p>
      <div className="modules-menu-cards">
        {selectModules()}
      </div>
    </div>
  )
}